import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=471ad380&lang=pug&"
import script from "./Goods.vue?vue&type=script&lang=ts&"
export * from "./Goods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports